import React, { useEffect, useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  sizePerPageList,
  formatDateMonth,
  isDateFormat,
  parseDateString,
  getAlignment,
  formatQuantity,
  isUUID,
  transformValue,
  showErrorDialog,
} from "../../utility";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { fetchExport, fetchExportNoBlob } from "./reportSlice";

export const ReportTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
  report,
  dispatch,
  paramsDownload,
}) => {
  const pageBefore = sizePerPage * (page - 1);

  // Transformasi data hanya dijalankan saat `data` berubah
  const transformedData = useMemo(() => {
    return data.map((item, index) => {
      const newItem = {
        no: (index + 1 + pageBefore).toString(),
        ...item,
      };

      for (const key in newItem) {
        if (isDateFormat(newItem[key])) {
          const dateObj = parseDateString(newItem[key]);
          newItem[key] = moment(dateObj).format("DD MMMM YYYY");
        }
      }
      return newItem;
    });
  }, [data, pageBefore]);
  console.log(transformedData, "transformedData");

  const actionFormatter = (cell, row) => (
    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Download</Tooltip>}
    >
      <div
        className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
        onClick={() => handleDownload(cell, row)}
      >
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/Files/Download.svg")} />
        </span>
      </div>
    </OverlayTrigger>
  );

  // Tentukan `columns` hanya ketika `data` berubah
  const isNumeric = (value) => {
    if (value === null || value === undefined) return false;
    return !isNaN(value) && !isNaN(parseFloat(value));
  };

  const getAlignment = (value) => {
    return isNumeric(value) ? "right" : "left";
  };

  const formatQuantity = (value) => {
    if (!isNumeric(value)) return value;

    return Number(value).toLocaleString("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const columns = useMemo(() => {
    if (transformedData.length === 0) return [];

    const firstObject = transformedData[0];

    const uuidKeys = Object.keys(firstObject).filter((key) =>
      isUUID(firstObject[key])
    );

    return Object.keys(firstObject)
      .map((key) => {
        const value = firstObject[key];
        const isRight = getAlignment(value) === "right";

        const commonProps = {
          text: key.replace(/_/g, " "),
          dataField: key,
          style: { minWidth: `${key.length * 10 + 50}px` },
          hidden: uuidKeys.includes(key),
          align: getAlignment(value),
        };

        return key === "no"
          ? commonProps
          : {
              ...commonProps,
              sort: true,
              sortCaret,
              headerSortingClasses,
              formatter: isRight && isNumeric(value) ? formatQuantity : null,
            };
      })
      .filter((col) => !col.dataField.includes("is_hide"))
      .concat(
        report === "JourneyDetail"
          ? [
              {
                text: "Action",
                dataField: "action",
                align: "center",
                formatter: actionFormatter,
              },
            ]
          : []
      );
  }, [transformedData, report]);

  console.log(columns, "columns");

  const handleDownload = async (e, row) => {
    const params = { ...paramsDownload, journey_id: row.journey_id };

    try {
      const response = await dispatch(fetchExport(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${report}.xlsx`;
        link.click();
      } else {
        const responseNoBlob = await dispatch(fetchExportNoBlob(params));
        if (responseNoBlob.payload.data.status_code !== 200) {
          showErrorDialog(responseNoBlob.payload.data.message);
        }
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const options = {
    page,
    sizePerPage,
    showTotal: true,
    totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  console.log(columns, "columns");

  return (
    <BootstrapTable
      remote
      wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      bordered={false}
      keyField="no"
      data={transformedData}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
      hover
    >
      <PleaseWaitMessage entities={loading ? null : transformedData} />
      <NoRecordsFoundMessage entities={loading ? null : transformedData} />
    </BootstrapTable>
  );
};
